<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  stroke-width="2"
  stroke="currentColor"
  class="h-5 w-5"
>
  <line
    x1="8"
    y1="6"
    x2="21"
    y2="6"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <line
    x1="8"
    y1="12"
    x2="21"
    y2="12"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <line
    x1="8"
    y1="18"
    x2="21"
    y2="18"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <line
    x1="3"
    y1="6"
    x2="3.01"
    y2="6"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <line
    x1="3"
    y1="12"
    x2="3.01"
    y2="12"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <line
    x1="3"
    y1="18"
    x2="3.01"
    y2="18"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
